import { cn } from '@/utils';

interface SJSkeletonProps {
  className?: string;
}

export function SJSkeleton({ className }: SJSkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-[12px] bg-[var(--sj-surface-muted)]',
        className
      )}
    />
  );
}
